<div class="card card-info d-flex flex-row my-3 ">
  <div class="flex-column p-2 d-flex type-room">
    <span class="strong flex-column">
      <strong>Room Type</strong>
    </span>
    <span class="strong flex-column">{{(room.rooms!==undefined) ? room.rooms[0].roomType : room.roomType}}</span>
    <span class="strong pt-2">
      <strong>Type of bed</strong>
    </span>
    <span class="strong">A double bed</span>
  </div>
  <div class="flex-column p-2 d-flex max-people">
    <span class="strong">
      <strong>Capacity</strong>
    </span>
    <i class="icon icon-multiple-users-silhouette" aria-hidden="true"></i>
    <span class="strong">{{(room.rooms!==undefined) ? ((room.rooms[0].maxPax) ? room.rooms[0].maxPax : '') : room.maxPax}} Person(s)</span>
  </div>
  <div class="flex-column p-2 d-flex rooms-price">
    <span class="strong">
      <strong>Price per night</strong>
    </span>
    <div *ngIf="!(room.netPriceProf ? true : false)">
      <a class="loader text-center justify-content-center ">
          <i class="fas fa-spinner fa-spin"></i>
      </a>
    </div>
    <span *ngIf="(room.netPriceProf ? true : false)" class="strong">
      <strong>${{room.netPriceProf | number:'1.2-2'}}-</strong>
    </span>
    <span class="strong pt-2">
      <strong>{{room.optionNightsNetTotalProf}}Tarifa Neta</strong>
    </span>
    <span class="strong">
      <strong></strong>
    </span>
    <div *ngIf="!(room.optionNightsNetTotalProf ? true : false)">
      <a class="loader text-center justify-content-center ">
          <i class="fas fa-spinner fa-spin"></i>
      </a>
    </div>
    <span *ngIf="(room.optionNightsNetTotalProf ? true : false)" class="strong">
      <strong>${{room.optionNightsNetTotalProf | number:'1.2-2'}}-</strong>
    </span>
  </div>
  <div class="flex-column p-2 d-flex options">
    <span class="strong">
      <strong>Options</strong>
    </span>
    <span aria-hidden="true">
      <i class="cr-icon fas fa-times"></i> Does not Include Meal Regime</span>
    <span aria-hidden="true">
      <i class="cr-icon fas fa-times"></i> You can not cancel or make changes</span>
  </div>
  <div class=" d-flex py-2 px-1  justify-content-center" *ngIf="select">
    <div class="btn-group" dropdown>
      <div class="form-group text-center px-2">
        <label for="elect-romms">
          <strong>Select</strong>
        </label>
        <select class="form-control" id="select-romms" [(ngModel)]="qtySelect" (ngModelChange)="selectRoom(select[index], qtySelect)" name="select-romms"
          [value]="0" [disabled]="select[index].selectArray.length === 1">
          <option *ngFor="let qty of select[index].selectArray" [value]="qty">{{qty}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
